import { makeStyles, TextField } from '@material-ui/core';
import React, { useState, useEffect } from 'react';

const useStyles = makeStyles({
  description: {
    width: '100%',
  },
});
const DescriptionInput = ({ setDirty, value, onChange, ...props }) => {
  const classes = useStyles();
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = (e) => {
    const val = e.target.value;
    setLocalValue(val);
    setDirty(true);
  };
  const handleBlur = (e) => {
    const val = e.target.value;
    setLocalValue(val);
    if (val !== value) {
      onChange(val);
    }
  };

  return (
    <TextField
      {...props}
      className={classes.description}
      onChange={handleChange}
      onBlur={handleBlur}
      multiline
      rowsMax={4}
      rows={4}
      value={localValue}
      placeholder={props.placeholder || 'description'}
      label={props.label || 'description'}
      variant={props.variant || 'filled'}
    />
  );
};

export default DescriptionInput;
